import {Button, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import AdhocImageUpload from "../AdhocImageUpload";
import AdhocImageGallary from "../AdhocImageGallary";
import {createPropertyInstruction, getPropertyInstruction} from "../../service/PropertyService";
import {getParkingFee} from "../../service/JobService";

export function ParkingFeeModel({show, job, handleSave, handleClose, message, setMessage}) {
    const [parkingFeeData, setParkingFeeData] = useState({description: "", fee: 0, images: []});
    const [isLoading, setIsLoading] = useState(false);
    const refreshParkingFeeData = () => {

        setIsLoading(true);
        getParkingFee(job.cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    setParkingFeeData(data);
                });
            } else {
                //If no instruction is found, no error, just
            }
        }).finally(() => setIsLoading(false));

    };

    const instructionDate = parkingFeeData.date ? new Date(parkingFeeData.date) : new Date();
    const localDate = instructionDate.toLocaleString();

    useEffect(() => {
        refreshParkingFeeData();
    }, [job]);

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-width" onClick={(e) => e.stopPropagation()}>
            <Form>
                <Modal.Header>
                    <Modal.Title>Parking Fee</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label><b>Job ID:</b> {job.cos_job_id}. <b>Date: </b>{job.date}</Form.Label>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Property Address:</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address"
                                      value={job.full_address}
                                      disabled/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="address">

                    </Form.Group>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Updated Date:</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address"
                                      value={localDate}
                                      disabled/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="fee">
                        <Form.Label>Parking Fee</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Fee"
                            disabled={isLoading}
                            min="0.01"  // Minimum value set to 0.01 to ensure the fee is above 0
                            value={parkingFeeData.fee}
                            onChange={(e) => setParkingFeeData({...parkingFeeData, fee: e.target.value})}
                        />
                        <Form.Text className="text-muted">
                            Please enter your parking fee. Enter "0" to delete entry.
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="instructions">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control type="text" placeholder="Enter Instructions"
                                      value={parkingFeeData.description}
                                      disabled={isLoading}
                                      onChange={(e) => setParkingFeeData({...parkingFeeData, description: e.target.value})}
                        />
                        <Form.Text className="text">
                            Please type notes if you need justifications.
                        </Form.Text>
                    </Form.Group>
                    {message &&
                        <Form.Text className="text-danger">
                            {message}
                        </Form.Text>
                    }
                </Modal.Body>
                <div style={{marginLeft: 20, marginRight: 20}}>
                    <AdhocImageUpload images={parkingFeeData.images}
                                      setImages={(images) => setParkingFeeData({...parkingFeeData, images})}/>
                    <AdhocImageGallary images={parkingFeeData.images}
                                       setImages={(images) => setParkingFeeData({...parkingFeeData, images})}/>
                </div>
                <Modal.Footer>
                    <Button variant="secondary"
                            disabled={isLoading}
                            onClick={(e) => handleClose(e)}>
                        Close
                    </Button>
                    <Button variant="primary"
                            disabled={isLoading}
                            onClick={(e) => handleSave(e, parkingFeeData)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};
